<template>
  <el-row class="register-payments-toolbar">
    <el-row>
      <el-col :xs="12" :sm="6" :lg="5">
        <el-input
          v-model="searchData.payment_number"
          placeholder="Номер платежа"
        />
      </el-col>
      <el-col :xs="12" :sm="6" :lg="5">
        <el-input v-model="searchData.act_number" placeholder="Номер акта" />
      </el-col>

      <el-col :xs="12" :sm="6" :lg="5">
        <el-input
          v-model="searchData.carrier_name"
          placeholder="Имя перевозчика"
        />
      </el-col>

      <el-col :xs="12" :sm="6" :lg="5">
        <el-input
          v-model="searchData.carrier_inn"
          placeholder="ИНН перевозчика"
        />
      </el-col>
      <el-col :xs="12" :sm="6" :lg="4">
        <el-select v-model="searchData['per-page']" placeholder="Кол-во">
          <el-option
            v-for="item in perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-for="i in dateFilters" :key="i.field" :xs="12" :sm="6" :lg="5">
        <el-date-picker
          v-model="searchData[i.field]"
          style="width: 100%"
          type="date"
          :placeholder="i.text"
          :picker-options="pickerOpt"
          value-format="yyyy-MM-dd"
        />
      </el-col>
      <el-col :xs="12" :sm="6" :lg="5">
        <el-select
          v-model="searchData.payment_status"
          placeholder="Статус"
          clearable
        >
          <el-option
            v-for="item in paymentsStatusFilter"
            :key="item.val"
            :label="item.name"
            :value="item.val"
          />
        </el-select>
      </el-col>

      <el-col :xs="12" :sm="6" :lg="5" class="btn-group">
        <el-button type="primary" style="width: 100%" @click="handleSearch">
          Поиск
        </el-button>
        <el-button plain @click="handleClear">Сбросить</el-button>
      </el-col>
      <el-col :xs="12" :sm="6" :lg="1" class="btn-group">
        <div
          v-if="paymentMenuItems.length"
          v-click-outside="onClickOutside"
          style="text-align: right"
          class="zv-nav-menu__dropdown"
        >
          <el-button
            plain
            type=""
            icon="el-icon-more"
            @click="visible = !visible"
          />

          <el-collapse-transition>
            <div v-if="visible" class="zv-nav-menu__sidemenu">
              <el-menu
                active-text-color="#2ECC71"
                background-color="#EEEEEE"
                :default-active="activeIndexMenu"
              >
                <template v-for="(item, j) in paymentMenuItems">
                  <el-menu-item
                    :key="j"
                    :disabled="
                      !showTablePaymentsMenu &&
                      item.typePayment !== 3 &&
                      item.typePayment !== 5
                    "
                    :index="item.name"
                    @click="handleClickMenu(item)"
                  >
                    {{ item.title }}
                  </el-menu-item>
                </template>
              </el-menu>
            </div>
          </el-collapse-transition>
        </div>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import {
  dateFilters,
  paymentMenuItems,
  paymentsStatusFilter,
  perPageOptions,
} from '../constants'
import { mapActions, mapGetters } from 'vuex'
import { pickerOpt } from '@/datas/consts'

import ClickOutside from 'vue-click-outside'

export default {
  name: 'TableOfPaymentsToolbar',
  directives: {
    ClickOutside,
  },
  props: {
    showTablePaymentsMenu: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paymentsStatusFilter,
      perPageOptions,
      pickerOpt,
      dateFilters,
      visible: false,
      activeIndexMenu: '1',
      paymentMenuItems,
      searchData: {
        act_number: '',
        payment_number: '',
        payment_type: '',
        payment_status: '',
        carrier_name: '',
        carrier_inn: '',
        search: undefined,
        date_from: undefined,
        date_to: undefined,
        'per-page': 50,
      },
      flights: [
        { name: 'в отчете', val: 1 },
        { name: 'без отчета', val: 0 },
      ],
      clients: [],
    }
  },
  computed: {
    ...mapGetters({
      getSearchClientList: 'clients/getList',
    }),
  },
  created() {
    this.fetchClients({ perPage: 9999 })
  },
  methods: {
    ...mapActions({
      fetchClients: 'clients/fetchClients',
    }),
    createClientList() {
      this.clients = this.getSearchClientList().map(item => ({
        name: item.name,
      }))
    },
    querySearch(queryString, cb) {
      var links = this.clients

      if (queryString.length > 2) {
        var results = links.filter(
          item =>
            item.name.toLowerCase().indexOf(queryString.toLowerCase()) !== -1,
        )

        cb(results)
      }
    },
    handleClickMenu(item) {
      this.$emit('setDialog', item.name)
      this.visible = false
    },
    onClickOutside() {
      this.visible = false
    },
    handleSearch() {
      this.$emit('searchTablePayments', this.searchData)
    },
    handleClear() {
      this.searchData = {
        act_number: '',
        payment_number: '',
        payment_type: '',
        payment_status: '',
        carrier_name: '',
        carrier_inn: '',
        search: undefined,
        date_from: undefined,
        date_to: undefined,
        'per-page': 50,
      }
      this.handleSearch()
    },
  },
}
</script>

<style lang="sass">
.register-payments-toolbar
  .el-col
    padding-right: 16px
    margin-bottom: 16px

.el-autocomplete-suggestion
  width: fit-content !important
</style>
